import { Components, Theme } from '@mui/material/styles';

export const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  defaultProps: {
    classes: {
      root: 'MuiCustomScrollbarHelper',
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      paddingBottom: '0',
      paddingTop: theme.spacing(4),
      paddingInline: theme.spacing(4),

      '&:first-child': {
        paddingTop: theme.spacing(4),
      },

      '&:last-child': {
        paddingBottom: theme.spacing(6),
      },
    }),
  },
};
